module.exports = __webpack_public_path__ + "3fc91827.svg";